import Date from '../date/Date';
import ParameterValue from './ParameterValue';

export default class MemberGuestContract {
    constructor() {
        this.id = null;
        this.memberId = null;
        this.start = null;
        this.type = 'guest';
        this.end = null;
        this.terminationReason = null;
        this.deleted = false;
        this.invalidChanges = [];
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        let guestContract = new MemberGuestContract();
        guestContract.id = data.id;
        guestContract.start = data.start !== null ? Date.fromIso8601(data.start) : null;
        guestContract.end = data.end !== null ? Date.fromIso8601(data.end) : null;
        guestContract.memberId = data.memberId;
        guestContract.invalidChanges = [];

        guestContract.terminationReason = null;
        if (data.terminationReason && data.terminationReason.data) {
            guestContract.terminationReason = ParameterValue.fromData(data.terminationReason.data);
        }

        return guestContract;
    }

    isNew() {
        return this.id === null;
    }

    isActive() {
        let today = Date.today();
        return this.start !== null && this.start.isBeforeOrEqual(today) && (this.end === null || this.end.isAfterOrEqual(today));
    }

    serialize() {
        return {
            id: this.id,
            memberId: this.memberId,
            type: 'guest',
            start: this.start !== null ? this.start.toIso8601() : null,
            end: this.end !== null ? this.end.toIso8601() : null,
            terminationReasonId: null === this.terminationReason ? null : this.terminationReason.id
        };
    }
}
